// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isNumber',
    standalone: false,
})
export class IsNumberPipe implements PipeTransform {
    transform (input: any): boolean {
        return typeof input === 'number' && !isNaN(input);
    }
}
